import { useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";

import clsx from "clsx";
import StarIcon from "~/assets/star.png";
import "./FrequencySelection.css";
import { MACHINE_DISCOUNT_MAP } from "../../utils/constants.js";
import { selectFrequency } from "../../store/slices/frequency-slice.js";

const FrequencySelection = ({ data, deliveryCommitmentData }) => {
  const machine = useSelector((state) => state.machine.machine);

  const frequency = useSelector((state) => state.frequency.frequency);

  const dispatch = useDispatch();

  const sellingPlans = data?.DynamicBox?.sellingPlanGroup
    ? Object.values(data.DynamicBox.sellingPlanGroup)
    : [];

  const deliveryCommitmentSellingPlans = deliveryCommitmentData?.DynamicBox?.sellingPlanGroup
    ? Object.values(deliveryCommitmentData.DynamicBox.sellingPlanGroup)
    : [];

  const sortedDeliveryCommitmentSellingPlans = useMemo(() => {
    return deliveryCommitmentSellingPlans.sort((a, b) => {
      const numA = parseInt(a.title.match(/(\d+)\sDeliveries/)?.[1] || 0, 10);
      const numB = parseInt(b.title.match(/(\d+)\sDeliveries/)?.[1] || 0, 10);
      const intervalA = parseInt(a.title.match(/\((Every\s(\d+)\s)?Month/)?.[2] || 1, 10);
      const intervalB = parseInt(b.title.match(/\((Every\s(\d+)\s)?Month/)?.[2] || 1, 10);

      return numA - numB || intervalA - intervalB;
    });
  }, [deliveryCommitmentSellingPlans]);

  const groupedDeliveries = useMemo(() => {
    return sortedDeliveryCommitmentSellingPlans.reduce((groups, delivery) => {
      const interval = delivery.intervalCount;
      if (!groups[interval]) {
        groups[interval] = [];
      }
      groups[interval].push(delivery);
      return groups;
    }, {});
  }, [sortedDeliveryCommitmentSellingPlans]);

  const isMostPopular = (plan) => plan.title.toLowerCase().replace(/\s+/g, "-") === "every-month";

  const renderSellingPlans = (plans, selectedFrequency) => {
    return plans.map((plan, index) => {
      let interval = plan.title.toLowerCase().replace(/\s+/g, "-");
      let showDiscount = interval.includes("deliveries-commitment");

      let deliveryCommitment = parseInt(plan.title.match(/(\d+)\sDeliveries/)?.[1] || 0, 10);

      return (
        <button
          key={index}
          onClick={() => dispatch(selectFrequency(interval))}
          className={clsx("freq-option", {
            "most-popular-freq": interval === "every-month",
            selected: selectedFrequency === interval,
          })}>
          {/* {interval === "every-month" && <img className="star-icon" src={StarIcon} alt="Star" />} */}
          {plan.title}
          {interval === "every-month" && <span className="freq-popular-badge">POPULAR</span>}
          {showDiscount && (
            <span className="machine-discount">
              Machine ${MACHINE_DISCOUNT_MAP[deliveryCommitment] || 0} off
            </span>
          )}
        </button>
      );
    });
  };

  return (
    <div className="section frequency-selection">
      <h2>2. Choose Your Frequency</h2>
      {/* <p>Don't stress, you can always update this later on!</p> */}
      <div className="frequency-options">
        {sellingPlans.length > 0 && renderSellingPlans(sellingPlans, frequency)}
        {/* {machine === "need" &&
          deliveryCommitmentSellingPlans.length > 0 &&
          renderSellingPlans(deliveryCommitmentSellingPlans, frequency)} */}
      </div>

      {/* {sellingPlans.some(isMostPopular) && (
        <div className="most-popular-copy-wrapper">
          <img className="star-icon" src={StarIcon} alt="Star" />
          <span className="most-popular-copy">Most Popular</span>
        </div>
      )} */}
    </div>
  );
};

export default FrequencySelection;
